function currencyFormat(amount) {
  return Number.parseFloat(amount, 10).toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
}

function dateFormat(date) {
  if (!date || date === "N/A") return "";
  return new Date(date).toLocaleDateString();
}

export { currencyFormat, dateFormat };



// WEBPACK FOOTER //
// ./src/shared/components/helpers.js